import React, {useEffect, useState} from 'react';
import {Box, Button, Grid, Paper} from '@mui/material';
import {useNavigate} from "react-router-dom";
import {enqueueSnackbar} from "notistack";
import {useToolbar} from "../../components/ToolbarContext";
import AppointmentMapComponent from "../appointments-map/AppointmentMapComponent";
import { getCompany } from '../../shared/services/company.service';
import { ExternalCompanyDto } from '../../shared/dtos/company.dto';
import { logError } from '../../shared/services/logger.service';
import { isAuthRedirectError } from '../../shared/services/auth.service';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const toolbarContext = useToolbar();
  const [company, setCompany] = useState<ExternalCompanyDto | null>(null);


  useEffect(() => {
    getCompany(navigate)
    .then(c => setCompany(c))
    .catch(e => {
      if (isAuthRedirectError(e)) return;
      logError('Error fetching company', {}, e);
      enqueueSnackbar('Error fetching company', {variant: 'error'});
    });
  }, [navigate]);

  useEffect(() => {
    if(company == null) {
      return;
    }
    toolbarContext.setTitle(`${company?.name}`);
    toolbarContext.setCenteredContent(
      <Box display="flex" width="100%" justifyContent="center" alignItems="center">
      </Box>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  const handleAddAppointmentClick = () => {
    navigate('/appointments/new');
  }

  const handleMapViewClick = () => {
    navigate('/appointments/map');
  }

  const handleEstimateAppointmentsClick = () => {
    navigate('/appointments');
  }

  const handleWorkOrdersClick = () => {
    navigate('/work-orders');
  }

  const handleViewEstimatesClick = () => {
    navigate('/estimates');
  }

  const handleViewInvoicesClick = () => {
    navigate('/invoices');
  }

  return (
    <Paper sx={{height: '100%', overflow: 'hidden'}}>
      <Grid container style={{ height: '100%' }}>
        <Grid item xs={12} md={6}>
          <Box display="flex" width="100%" paddingTop={'30px'} justifyContent="center" alignItems="center">
            <Grid container width={'400px'}>
              <Grid item xs={6}>
                <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
                  <Button variant="contained" sx={{ margin: 1 }} onClick={() => handleAddAppointmentClick()}>Add Appointment</Button>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
                  <Button variant="contained" sx={{ margin: 1 }} onClick={() => handleMapViewClick()}>Map View</Button>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
                  <Button variant="contained" sx={{ margin: 1 }} onClick={() => handleEstimateAppointmentsClick()}>Estimate Appointments</Button>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
                  <Button variant="contained" sx={{ margin: 1 }} onClick={() => handleWorkOrdersClick()}>Jobs</Button>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
                  <Button variant="contained" sx={{ margin: 1 }} onClick={() => handleViewEstimatesClick()}>View Estimates</Button>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box display="flex" width="100%" height="100%" justifyContent="center" alignItems="center">
                  <Button variant="contained" sx={{ margin: 1 }} onClick={() => handleViewInvoicesClick()}>Invoices</Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} style={{height: '100%', boxSizing: 'border-box', overflow: 'hidden'}}>
          <AppointmentMapComponent/>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default HomePage;
